import { Component } from '@angular/core';
import { IUserJob } from './core/IUserJob';

import { AIJobState } from './ai-jobs-state';
import { AIJobsService } from './ai-jobs.service';

@Component({
  selector: 'biz-ai-job',
  templateUrl: './ai-job.component.html',
  styleUrls: ['./ai-job.component.scss']
})
export class AIJobComponent {
     public userJobs: Array<IUserJob>;
      public waitingUserJobs: Array<IUserJob>;
      public executedUserJobs: Array<IUserJob>;
      public isLoadingJobs = true;
      public selectedTab: number = 0;

  constructor(private _AIJobService: AIJobsService){}

  async ngAfterViewInit() {
    await this.getAllData();
  }

  public areThereUserJobs(): boolean {
    return (this.waitingUserJobs && this.waitingUserJobs.length > 0 ) || (this.executedUserJobs && this.executedUserJobs.length > 0 )
  }

  public async getAllData() {    
    this.isLoadingJobs = true;
    this.userJobs = await this._AIJobService.getAll();
    this.waitingUserJobs = this.userJobs.filter(userjob => userjob && userjob.state === AIJobState[AIJobState.Waiting]);
    this.executedUserJobs = this.userJobs.filter(userjob => userjob && userjob.state === AIJobState[AIJobState.Executed]);
    this.isLoadingJobs = false;    
  }
}
